import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

i18next
  .use(LanguageDetector)
  .init({
    defaultNS: 'translation',
    lng: 'en',
  })

i18next.addResourceBundle('en', 'translation', require('./en.yml').en)
i18next.addResourceBundle('en-GB', 'translation', require('./en.yml')['en-GB'])
i18next.addResourceBundle('en-CA', 'translation', require('./en.yml')['en-CA'])
i18next.addResourceBundle('es-MX', 'translation', require('./es-MX.yml')['es-MX'] )
i18next.addResourceBundle('fr-CA', 'translation', require('./fr-CA.yml')['fr-CA'])
i18next.addResourceBundle('fr-FR', 'translation', require('./fr-FR.yml')['fr-FR'])
i18next.addResourceBundle('de-DE', 'translation', require('./de-DE.yml')['de-DE'])
i18next.addResourceBundle('ja-JP', 'translation', require('./ja-JP.yml')['ja-JP'])
i18next.addResourceBundle('ko-KR', 'translation', require('./ko-KR.yml')['ko-KR'])
i18next.addResourceBundle('vi-VN', 'translation', require('./vi-VN.yml')['vi-VN'])
i18next.addResourceBundle('zh-TW', 'translation', require('./zh-TW.yml')['zh-TW'])

export default i18next

export const t = (...args) => i18next.t(...args)
